/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import SVG from "react-inlinesvg";
import { ModalProgressBar } from "../../../_themeBase/_partials/controls";
import { ShowToast, toAbsoluteUrl, ToastType } from "../../../_themeBase/_helpers";
import * as auth from "../Auth";
import { changeMobile, sendSms } from "../Auth/_redux/authCrud";

function ChangeMobile(props) {
  // Fields
  const { intl } = props;
  const [loading, setloading] = useState(false);
  const [isError, setisError] = useState(false);
  const [checkSms, setCheckSms] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const menu = useSelector((state) => state.auth.menu, shallowEqual);
  useEffect(() => { }, [user]);
  // Methods
  const history = useHistory()

  const sendSmsCode = () => {
    setloading(true);
    setisError(false);

    sendSms(user.username, formik.values["password"], formik.values["mobile"])
      .then(() => {
        setloading(false);
        setCheckSms(true)
        formik.setStatus("کد دستیابی به شماره مورد نظر شما ارسال شد.لطفا کد را وارد نمونده و ذخیره را بزنید.");
      })
      .catch((error) => {
        setloading(false);
        setCheckSms(false)
        setisError(true);
        if (error.response) {
          formik.setStatus(error.response.data.Message);
        }
        else {
          formik.setStatus("اجرای عملیات با مشکل مواجه شد. دوباره تلاش کنید");
        }

      });

  };


  const saveUser = (values, setStatus, setSubmitting) => {
    setloading(true);
    setisError(false);
    // const updatedUser = Object.assign(user, {
    //   mobile: values.mobile,
    // });
    // // user for update preparation
    // dispatch(props.setUser(updatedUser));

    // const userLocal = JSON.parse(sessionStorage.authUser);

    changeMobile(user.id, values["mobile"], values["smsCode"])
      .then(() => {
        setloading(false);
        setStatus("شماره همراه با موفقیت تغییر کرد");

        const updatedUser = Object.assign(user, {
          mobile: values.mobile,
        });

        sessionStorage.setItem(
          "authUser",
          JSON.stringify(updatedUser)
        );
        props.fulfillUser(user, menu);

        history.push("/user-profile/change-mobile");
      })
      .catch((error) => {
        setloading(false);
        setSubmitting(false);
        setisError(true);
        if (error.response) {
          setStatus(error.response.data.Message);
        }
        else {
          formik.setStatus("اجرای عملیات با مشکل مواجه شد. دوباره تلاش کنید");
        }

      });

  };
  // UI Helpers
  const initialValues = {
    password: "",
    mobile: "",
    smsCode: "",
  };
  const Schema = Yup.object().shape({
    password: Yup.string().required("پر کردن فیلد الزامی است"),
    mobile: Yup.string()
      .min(11, "شماره همراه باید 11 کاراکتر باشد")
      .max(11, "شماره همراه باید 11 کاراکتر باشد")
      .required("پر کردن فیلد الزامی است"),
    smsCode: Yup.string().required("پر کردن فیلد الزامی است"),
    // smsCode: Yup.string()
    //   .required("پر کردن فیلد الزامی است")
    //   .when("mobile", {
    //     is: (val) => (val && val.length > 0 ? true : false),
    //     then: Yup.string().oneOf(
    //       [Yup.ref("mobile")],
    //       "تکرار رمز عبور با رمز عبور جدید مطابق نیست."
    //     ),
    //   }),
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveUser(values, setStatus, setSubmitting);
    },
    onReset: (values, { resetForm }) => {
      resetForm();
    },
  });

  return (
    <form className="card card-custom" onSubmit={formik.handleSubmit}>
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">
            تغییر شماره همراه
          </h3>
          <span className="text-muted font-weight-bold font-size-sm mt-1">
            شماره همراه خود را تغییر دهید
          </span>
        </div>
        <div className="card-toolbar">
          {!checkSms && <button
            type="button"
            className="btn btn-primary mr-2"
            onClick={sendSmsCode}
          // disabled={
          //   formik.isSubmitting || (formik.touched && !formik.isValid)
          // }
          >
            ارسال پیامک
            {/* {formik.isSubmitting} */}
          </button>}
          {checkSms && <button
            type="submit"
            className="btn btn-primary mr-2"
            disabled={
              formik.isSubmitting || (formik.touched && !formik.isValid)
            }
          >
            ذخیره
            {formik.isSubmitting}
          </button>}
          {/* <Link
            to="/user-profile/profile-overview"
            className="btn btn-secondary"
          >
            انصراف
          </Link> */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Form */}
      <div className="form">
        <div className="card-body">
          {/* begin::Alert */}
          {formik.status && isError && (
            <div
              className="alert alert-custom alert-light-danger fade show mb-10"
              role="alert"
            >
              <div className="alert-icon">
                <span className="svg-icon svg-icon-3x svg-icon-danger">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")}
                  ></SVG>{" "}
                </span>
              </div>
              <div className="alert-text font-weight-bold">
                {formik.status}
              </div>
              <div className="alert-close" onClick={() => setisError(false)}>
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <i className="ki ki-close"></i>
                  </span>
                </button>
              </div>
            </div>
          )}
          {formik.status && !isError && checkSms && (
            <div
              className="alert alert-custom alert-light-success fade show mb-10"
              role="alert"
            >
              <div className="alert-icon">
                <span className="svg-icon svg-icon-3x svg-icon-success">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")}
                  ></SVG>{" "}
                </span>
              </div>
              <div className="alert-text font-weight-bold">
                {formik.status}
              </div>
            </div>
          )}
          {/* end::Alert */}
          {!checkSms && <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              رمز کاربری
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="رمز عبور خود را وارد نمایید"
                className={`form-control form-control-lg form-control-solid mb-2 ${getInputClasses(
                  "password"
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password &&
                formik.errors.password ? (
                <div className="invalid-feedback">
                  {formik.errors.password}
                </div>
              ) : null}
              {/* <a href="#" className="text-sm font-weight-bold">
                آیا رمز عبور خود را فراموش کرده اید؟
              </a> */}
            </div>
          </div>}
          {!checkSms && <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              شماره همراه
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="text"
                placeholder="شماره همراه ( 11 کاراکتر - شماره را با صفر وارد نمایید)"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "mobile"
                )}`}
                name="mobile"
                {...formik.getFieldProps("mobile")}
              />
              {formik.touched.mobile && formik.errors.mobile ? (
                <div className="invalid-feedback">{formik.errors.mobile}</div>
              ) : null}
            </div>
          </div>}
          {checkSms && <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              پیامک ارسال شده
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="text"
                placeholder="پیامکی که برای شما ارسال شده است را وارد نمایید"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "smsCode"
                )}`}
                name="smsCode"
                {...formik.getFieldProps("smsCode")}
              />
              {formik.touched.smsCode && formik.errors.smsCode ? (
                <div className="invalid-feedback">
                  {formik.errors.smsCode}
                </div>
              ) : null}
            </div>
          </div>}
        </div>
      </div>
      {/* end::Form */}
    </form>
  );
}

export default connect(null, auth.actions)(ChangeMobile);
